import {
  Box,
  Dialog,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { ReportDto } from "interfaces/report";
import { flatten, uniq } from "lodash";
import { useMemo } from "react";
import { FixedSizeList, ListChildComponentProps } from "react-window";

interface Props {
  handleClose: Function;
  open: boolean;
  report: ReportDto;
}

export default function SharedEmailsDialog({
  handleClose,
  open,
  report,
}: Props) {
  const emails = useMemo(() => {
    return uniq([
      ...report.emails,
      ...flatten(
        report.partners.map((partner) =>
          (partner.emails || []).map(
            (email) => `${email} - ( ${partner.name} company )`
          )
        )
      ),
    ]);
  }, [report]);

  const renderEmailList = (props: ListChildComponentProps) => {
    const { index, style } = props;

    return (
      <ListItem style={style} key={index} component="div" disablePadding>
        <ListItemButton>
          <ListItemText primary={emails[index]} />
        </ListItemButton>
      </ListItem>
    );
  };

  return (
    <Dialog onClose={(e) => handleClose(e)} open={open}>
      <Box padding={2} minWidth={500}>
        <Box>
          <Stack spacing={2}>
            <Typography variant="h5">SHARED EMAIL LIST:</Typography>

            <FixedSizeList
              width="100%"
              height={
                (emails || []).length * 46 < 200
                  ? (emails || []).length * 46
                  : 200
              }
              itemSize={40}
              itemCount={(emails || []).length || 0}
            >
              {renderEmailList}
            </FixedSizeList>
          </Stack>
        </Box>
      </Box>
    </Dialog>
  );
}
